import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { label: 'Home', href: '#home' },
    { label: 'Services', href: '#services' },
    { label: 'Why Fintage', href: '#why-fintage' },
    { label: 'About', href: '#about' },
    { label: 'Contact', href: '#contact' }
  ];

  const solutionsItems = [
    { label: 'Core MFI Solution', href: '#core-mfi' },
    { label: 'Deposit Management', href: '#deposits' },
    { label: 'Agency Banking', href: '#agency' },
    { label: 'Loan Origination', href: '#loan-origination' },
    { label: 'Reconciliation', href: '#reconciliation' },
    { label: 'HRMS', href: '#hrms' }
  ];


  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-28 md:h-32">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_b30690b0-f644-4148-910f-d50b0a56b6db/artifacts/bg4wuah7_Fintage%20logo_transparentBG.png"
              alt="Fintage Logo"
              className="h-24 md:h-32 w-auto !rounded-[9px]" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium text-sm"
              >
                {item.label}
              </a>
            ))}
            
            {/* Solutions Dropdown */}
            <DropdownMenu>
              <DropdownMenuTrigger className="flex items-center space-x-1 text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium text-sm cursor-pointer outline-none">
                <span>Solutions</span>
                <ChevronDown className="h-4 w-4" />
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-56 bg-white">
                {solutionsItems.map((solution) => (
                  <DropdownMenuItem key={solution.label} asChild>
                    <a
                      href={solution.href}
                      className="w-full cursor-pointer hover:bg-blue-50 px-2 py-2 text-sm text-gray-700 hover:text-blue-600"
                    >
                      {solution.label}
                    </a>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white">
              Get Started
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu">

            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              
              {/* Solutions in Mobile Menu */}
              <div className="space-y-2">
                <a
                  href="#solutions"
                  className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium block"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Solutions
                </a>
                <div className="pl-4 space-y-2">
                  {solutionsItems.map((solution) => (
                    <a
                      key={solution.label}
                      href={solution.href}
                      className="text-gray-600 hover:text-blue-600 transition-colors duration-200 text-sm block"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {solution.label}
                    </a>
                  ))}
                </div>
              </div>
              
              <Button className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white w-full">
                Get Started
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;